//basic
import React from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'

//api
import { api } from '../../../functions/api'

//custom components
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton'

//material-ui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItem,
} from '@material-ui/core'

//style
import './AddEditXmlExports.scss'
import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch'


@inject('translate')
@inject('internal')
@observer
export default class AddEditXmlExports extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      loadingBtn: false,
      data: [],
      selected: [],
      title: '',
      rabat: '',
      include_coupons: false,
      productListChanged: false,
      productList: [],
      products: [],
      contentHeight: 'auto'
    }
  }

  isEditMode = null

  componentDidMount() {

    this.isEditMode = toJS(this.props.internal.actionEdit)

    if (this.isEditMode.edit) {
      this.loadProductList()
      this.loadItem()
    } else {
      this.setState({ loading: false })
    }
  }

  formatItems(items) {
    return items.map(item => ({
      value: item.id,
      label: item.name,
    }))
  }

  itemData = {}
  loadItem = async () => {
    let idItem = toJS(this.props.internal.actionEdit.id)

    let load_item = await api({
      method: 'get',
      url: `lists/xml-exports/${idItem}`,
      authorization: this.props.internal.user.access_token,
    })

    if (load_item.success) {
      this.itemData = load_item.data.data
      this.setState({
        loading: false,
        title: load_item.data.data.title,
        rabat: load_item.data.data.rabat || '',
        include_coupons: load_item.data.data.include_coupons,
        products: this.formatItems(load_item.data.data.products),
      })
    }
  }

  action = () => {
    let isEdit = toJS(this.props.internal.actionEdit.edit)
    this.setState({ loadingBtn: true })
    if (isEdit) {
      //update
      this.updateItem()
    } else {
      //create
      this.createItem()
    }
  }

  saveProducts = () => {
    if (false === this.state.productListChanged) {
      return Promise.resolve()
    }
    let recordId = toJS(this.props.internal.actionEdit.id)

    return api({
      method: 'put',
      url: `lists/xml-exports/${recordId}/pair-products`,
      authorization: this.props.internal.user.access_token,
      params: {
        product_id: this.state.products.map(item => item.value),
      },
    }).then(response => {
      if (true === response.success) {
        return Promise.resolve()
      }

      this.props.internal.setSnackbar(response.data.message, true, true)

      return Promise.reject(response.error)
    })

  }

  updateItem = async () => {
    let title = this.title.state.value
    if (title !== '') {
      let idItem = toJS(this.props.internal.actionEdit.id)

      let update_data = await api({
        method: 'patch',
        url: `lists/xml-exports/${idItem}`,
        authorization: this.props.internal.user.access_token,
        params: {
          title,
          rabat: this.state.rabat,
          include_coupons: this.state.include_coupons,
        },
      })

      if (update_data.success === true) {
        Promise.all([
          this.saveProducts(),
        ]).then(() => {
          this.props.internal.setSnackbar(update_data.data.message, true)
          this.setState({ loadingBtn: false })
          this.props.onClose(true)
        })
      } else {
        if (update_data.data.data.hasOwnProperty('errors')) {
          const firstKey = Object.keys(update_data.data.data.errors).shift()
          this.props.internal.setSnackbar(update_data.data.data.errors[firstKey][0], true)
        } else {
          this.props.internal.setSnackbar(update_data.data.message, true)
        }
        this.setState({ loadingBtn: false })
      }
    } else {
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
      this.setState({ loadingBtn: false })
    }

  }

  createItem = async () => {
    let title = this.title.state.value
    if (title !== '') {
      this.setState({ loadingBtn: true })
      let update_data = await api({
        method: 'post',
        url: `lists/xml-exports`,
        authorization: this.props.internal.user.access_token,
        params: {
          title,
          rabat: this.state.rabat,
          include_coupons: this.state.include_coupons,
        },
      })

      if (update_data.success === true || (update_data.success === false && update_data.status === 201)) {
        this.props.internal.setSnackbar(update_data.data.message, true)
        this.setState({ loadingBtn: false })
        this.props.onClose(true)
      }
    } else {
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
      this.setState({ loadingBtn: false })
    }

  }

  loadProductList = async () => {
    let response = await api({
      method: 'get',
      url: `lists/coupons/product-list`,
      authorization: this.props.internal.user.access_token,
    })

    if (response.success) {
      this.setState({
        productList: this.formatItems(response.data.data),
      })
    }
  }

  editCategory = {}

  stretchContent = () => {
    this.setState({contentHeight: 405 })
  }

  resetContent = () => {
    this.setState({contentHeight: 'auto'})
  }

  handleChangeRabat = (event) => {
    this.setState({rabat: event.target.value})
  }

  handleChangeCheckbox = (field, event) => {
    this.setState({[field]: event.target.checked})
  }

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={() => this.props.onClose(false)}
        aria-labelledby="form-dialog-title"
        scroll={'body'}
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        {this.state.loading
          ?
          <div style={{ minHeight: '100px' }}>
            <CircularProgress className={'circular-progress'}/>
          </div>
          :
          <DialogContent style={{minHeight: this.state.contentHeight}}>
            <CustomInput
              ref={ref => this.title = ref}
              text={this.props.translate.i18n.MODULES['XML_EXPORTS'].TITLE}
              value={this.state.title}
              id={'title'}
              className={'w-100'}
              required
            />

            <FormControl className="select-rabat w-100">
              <InputLabel
                shrink
                htmlFor="xml-export-rabat"
                className={"label-select-type"}
              >
                {this.props.translate.i18n.MODULES.XML_EXPORTS.RABAT_INCLUDE}
              </InputLabel>
              <Select
                classes={{
                  root: "xml-export-rabat-root"
                }}
                value={this.state.rabat}
                onChange={this.handleChangeRabat}
                displayEmpty
                inputProps={{
                  name: "xml_export_rabat",
                  id: "xml-export-rabat"
                }}
              >
                <MenuItem value="">{this.props.translate.i18n.GLOBAL.NO}</MenuItem>
                <MenuItem value="rabat_1">{this.props.translate.i18n.MODULES.PRODUCTS.RABAT_1}</MenuItem>
                <MenuItem value="rabat_2">{this.props.translate.i18n.MODULES.PRODUCTS.RABAT_2}</MenuItem>
                <MenuItem value="rabat_3">{this.props.translate.i18n.MODULES.PRODUCTS.RABAT_3}</MenuItem>
                <MenuItem value="rabat_4">{this.props.translate.i18n.MODULES.PRODUCTS.RABAT_4}</MenuItem>
                <MenuItem value="rabat_5">{this.props.translate.i18n.MODULES.PRODUCTS.RABAT_5}</MenuItem>
              </Select>
            </FormControl>

            <ListItem dense onChange={e => this.handleChangeCheckbox('include_coupons', e)} className={'list-item'}>
              <input
                id={"include_coupons"}
                type="checkbox"
                value={this.state.include_coupons}
                defaultChecked={
                  this.state.include_coupons
                }
              />
              <label htmlFor={"include_coupons"}>{this.props.translate.i18n.MODULES.XML_EXPORTS.INCLUDE_COUPONS}</label>
            </ListItem>
            {this.isEditMode && this.isEditMode.edit && (
              <SelectSearch
                onMenuOpen={() => this.stretchContent()}
                onMenuClose={() => this.resetContent()}
                className={'mt-10'}
                options={this.state.productList}
                value={this.state.products}
                label={this.props.translate.i18n.MODULES.LISTS_COUPONS.PRODUCTS}
                onChange={products => this.setState({ productListChanged: true, products })}
                isMulti
              />
            )}
          </DialogContent>
        }
        <DialogActions>
          <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
            {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
          </Button>
          <CustomButton
            progressBar={this.state.loadingBtn}
            onClick={this.action}
            mystyle={'btn-white-bg'}
            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
            justText
            disabled={this.state.loading}
          />
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/XmlExports/AddEdit/AddEditXmlExports.js